<template>
  <div ref="project" class="section-grid-item project">
    <h2 class="p-header">{{ projectData.title }}</h2>
    <div v-if="embed">
      <slot />
    </div>
    <div
      v-else
      class="img-wrapper"
      @click="styleAndOpenGallery(0, openGallery)"
    >
      <img
        class="p-showcase"
        v-lazy="video[0].src || video[0].thumb"
        alt="Travelog Demo Preview"
      />
      <div class="overlay" />
      <img class="play-button" :src="playButton" alt="play button" />
    </div>
    <div class="p-text">
      <p>
        {{ projectData.description }}
      </p>
      <p>
        <a class="p-link" :href="projectData.link.src" target="_blank">{{
          projectData.link.text
        }}</a>
        <span>|</span>
        <a class="p-link" :href="projectData.code.src" target="_blank">{{
          projectData.code.text
        }}</a>
      </p>
      <p>{{ projectData.stack }}</p>
    </div>
    <LightBox
      :ref="`lightbox${index}`"
      :media="video"
      :show-light-box="false"
      :closable="true"
      :showThumbs="false"
    />
  </div>
</template>

<script>
  import playButton from '@/assets/icons/play_button.svg'
  import LightBox from 'vue-image-lightbox'
  import { mapState } from 'vuex'
  export default {
    name: 'Project',
    props: {
      projectData: {
        type: Object,
        default: () => {},
        required: true
      },
      index: {
        type: Number,
        default: null,
        required: false
      },
      embed: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data() {
      return {
        playButton
      }
    },
    computed: {
      ...mapState(['styleBeforeLightbox', 'windowSize']),
      video() {
        const { width, height } = this.windowSize,
          dimensions =
            height < 500 ? { height } : { width: Math.min(width, 900) }
        const video = [
          {
            thumb: this.projectData.media.imgs[0],
            sources: [
              {
                src: this.projectData.media.vid,
                type: 'video/mp4'
              }
            ],
            type: 'video',
            autoplay: true,
            ...dimensions
          }
        ]
        return video
      }
    },
    components: {
      LightBox
    },
    methods: {
      openGallery() {
        const lightbox = `lightbox${this.index}`
        this.$refs[lightbox].showImage(0)
      },

      styleAndOpenGallery(index, cb) {
        this.$refs.project.style = this.styleBeforeLightbox
        cb(index)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @include sectionGridItem {
    .section-grid-item.project {
      .p-header {
        text-align: center;
        font-size: 2rem;
        margin: 1rem auto 1.5rem auto;
        font-weight: 300;
        max-width: 680px;
      }
      .img-wrapper {
        position: relative;
        width: 100%;
        cursor: pointer;

        .play-button {
          border-radius: 50%;
          box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19),
            0 6px 6px rgba(0, 0, 0, 0.23);
          transition: all $transition;
          width: 4rem;
          position: absolute;
          left: calc(50% - 2rem);
          top: calc(50% - 2rem);
        }

        .p-showcase {
          width: 100%;
          max-height: 600px;
          vertical-align: bottom;
        }
        .overlay {
          position: absolute;
          top: 0;
          width: 100%;
          height: 100%;
          transition: background-color $transition;
        }
        &:hover {
          .overlay {
            background-color: rgba(0, 0, 0, 0.4);
          }
          .play-button {
            box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25),
              0 10px 10px rgba(0, 0, 0, 0.22);
          }
        }
      }
      p {
        font-size: 14px;
        text-align: center;
        margin: 0 auto;
        z-index: 4;
        max-width: 500px;
        margin-bottom: 1rem;
      }
      .p-text {
        background-color: rgba(0, 36, 38, 0.96);
        padding: 1rem 0;
      }
      .stack {
        font-weight: 600;
      }
      .p-link {
        @include underline-on-hover($link-color);
        padding: 0 0.75rem;
        &:first-child {
          margin-right: 0.5rem;
        }
        &:last-child {
          margin-left: 0.5rem;
        }
      }
    }
  }
</style>
